// Nozzles and users animation
(function () {
    const screenHeight = document.documentElement.clientHeight;
    const listItems = document.querySelectorAll(`.users__item`);
    const nozzles = document.querySelectorAll(`.nozzles__inner`);

    const isPartiallyVisible = (element) => {
        const elementBoundary = element.getBoundingClientRect();
        const top = elementBoundary.top;
        const bottom = elementBoundary.bottom;
        const height = elementBoundary.height;

        return (top + height >= 0) && (height + screenHeight > bottom);
    };

    const scrolling = () => {
        listItems.forEach((item) => {
            if (isPartiallyVisible(item)) {
                item.classList.add(`users__item--active`);
            }
        });

        nozzles.forEach((item) => {
            if (isPartiallyVisible(item)) {
                item.classList.add(`nozzles__inner--active`);
            }
        });
    };

    window.addEventListener(`scroll`, scrolling);
})();

// Menu animation
(function () {
    const header = document.querySelector(`.header`);

    if (header) {
        const headerMenu = header.querySelector(`.header__menu`);

        window.addEventListener(`scroll`, (evt) => {
            if (window.scrollY > 0) {
                header.classList.add(`header--reduce`);
                header.classList.remove(`header--reduce-out`, `header--visible`);
            } else {
                header.classList.add(`header--reduce-out`);

                headerMenu?.addEventListener(`animationend`, () => {
                    if (window.scrollY <= 0) {
                        header.classList.add(`header--visible`);
                        header.classList.remove(`header--reduce`, `header--reduce-out`, `header--visible`);
                    }
                });
            }
        });
    }
})();

// Cta-top animation
(function () {
    const usersBlock = document.querySelector(`.users`);
    const ctaTopBlock = document.querySelector(`.cta-top`);

    if (usersBlock && ctaTopBlock) {
        window.addEventListener(`scroll`, (evt) => {
            const elementBoundary = usersBlock.getBoundingClientRect();
            const top = elementBoundary.top;
            if (top <= 0) {
                ctaTopBlock.classList.add(`cta-top--visible`);
            } else {
                ctaTopBlock.classList.remove(`cta-top--visible`);
            }
        });
    }
})();